import {
  Users,
  LayoutDashboard,
  GraduationCap,
  Star,
  Sparkles,
  MessageSquare,
  Settings,
  Video,
  BookOpen,
  CreditCard,
  Calendar,
  BarChart3,
  Package,
  ShoppingCart,
  Radio,
  Heart,
  Shield,
  FileText,
  Megaphone,
  Globe,
  Layers,
  Trophy,
  type LucideIcon,
} from "lucide-react";
import type { DashboardRole } from "@/lib/rbac";

export interface NavItem {
  title: string;
  href?: string;
  icon: LucideIcon;
  roles: DashboardRole[];
  children?: NavItem[];
}

export const adminNavigation: NavItem[] = [
  {
    title: "Dashboard",
    href: "/admin/dashboard",
    icon: LayoutDashboard,
    roles: ["admin"],
  },
  {
    title: "Users",
    href: "/admin/users",
    icon: Users,
    roles: ["admin"],
  },
  {
    title: "Training",
    icon: GraduationCap,
    roles: ["admin"],
    children: [
      { title: "Training Center", href: "/admin/training/center", icon: GraduationCap, roles: ["admin"] },
      { title: "Categories", href: "/admin/training/categories", icon: Layers, roles: ["admin"] },
      { title: "Lessons", href: "/admin/training/lessons", icon: BookOpen, roles: ["admin"] },
      { title: "Quizzes", href: "/admin/training/quizzes", icon: FileText, roles: ["admin"] },
      { title: "Assignments", href: "/admin/training/assignments", icon: FileText, roles: ["admin"] },
      { title: "Class Config", href: "/admin/training/classes", icon: Settings, roles: ["admin"] },
      { title: "Notifications", href: "/admin/training/notifications", icon: FileText, roles: ["admin"] },
    ],
  },
  {
    title: "Toolkit",
    icon: Star,
    roles: ["admin"],
    children: [
      { title: "Astro Toolkit", href: "/admin/astrology/toolkit", icon: Star, roles: ["admin"] },
      { title: "Horoscope", href: "/admin/astrology/horoscope", icon: Globe, roles: ["admin"] },
      { title: "Wheel Signs", href: "/admin/astrology/wheel-signs", icon: Layers, roles: ["admin"] },
      { title: "Decan Info", href: "/admin/astrology/decan-info", icon: FileText, roles: ["admin"] },
      { title: "Decan Videos", href: "/admin/astrology/decan-videos", icon: Video, roles: ["admin"] },
      { title: "Tarot Toolkit", href: "/admin/tarot/toolkit", icon: Sparkles, roles: ["admin"] },
      { title: "Tarot Spreads", href: "/admin/tarot/spreads", icon: Sparkles, roles: ["admin"] },
      { title: "Tarot Cards", href: "/admin/tarot/cards", icon: Sparkles, roles: ["admin"] },
    ],
  },
  {
    title: "Testimonials",
    icon: MessageSquare,
    roles: ["admin"],
    children: [
      { title: "Create", href: "/admin/testimonials/create", icon: MessageSquare, roles: ["admin"] },
      { title: "Requests", href: "/admin/testimonials/requests", icon: MessageSquare, roles: ["admin"] },
    ],
  },
  {
    title: "Products",
    icon: Package,
    roles: ["admin"],
    children: [
      { title: "Categories", href: "/admin/products/categories", icon: Layers, roles: ["admin"] },
      { title: "Management", href: "/admin/products/management", icon: Package, roles: ["admin"] },
    ],
  },
  {
    title: "Commerce",
    icon: CreditCard,
    roles: ["admin"],
    children: [
      { title: "Packages", href: "/admin/packages", icon: Package, roles: ["admin"] },
      { title: "Payments", href: "/admin/payments", icon: CreditCard, roles: ["admin"] },
      { title: "Refunds", href: "/admin/refunds", icon: CreditCard, roles: ["admin"] },
      { title: "Orders", href: "/admin/orders", icon: ShoppingCart, roles: ["admin"] },
    ],
  },
  {
    title: "Content",
    icon: BookOpen,
    roles: ["admin"],
    children: [
      { title: "General Content", href: "/admin/content/general", icon: FileText, roles: ["admin"] },
      { title: "Spiritual Wisdom", href: "/admin/content/spiritual-wisdom", icon: Heart, roles: ["admin"] },
    ],
  },
  {
    title: "Miscellaneous",
    icon: Settings,
    roles: ["admin"],
    children: [
      { title: "Roles", href: "/admin/roles", icon: Shield, roles: ["admin"] },
      { title: "Social Advo", href: "/admin/social-advo", icon: Megaphone, roles: ["admin"] },
      { title: "Quarters", href: "/admin/quarters", icon: Calendar, roles: ["admin"] },
      { title: "Ritual Invocation", href: "/admin/ritual-invocation", icon: Sparkles, roles: ["admin"] },
      { title: "Webinars", href: "/admin/webinars", icon: Video, roles: ["admin"] },
      { title: "Calendar Events", href: "/admin/calendar-events", icon: Calendar, roles: ["admin"] },
      { title: "Reports", href: "/admin/reports", icon: BarChart3, roles: ["admin"] },
      { title: "Perennial Content", href: "/admin/perennial-content", icon: Sparkles, roles: ["admin"] },
    ],
  },

  // Shared features
  {
    title: "Blog",
    href: "/admin/blog",
    icon: BookOpen,
    roles: ["admin", "astrologer", "customer"],
  },
  {
    title: "Video",
    icon: Video,
    roles: ["admin", "astrologer", "customer"],
    children: [
      { title: "Management", href: "/admin/videos", icon: Video, roles: ["admin", "astrologer", "customer"] },
      { title: "Recordings", href: "/admin/recordings", icon: Video, roles: ["admin", "astrologer", "customer"] },
    ],
  },
  {
    title: "Calendar",
    href: "/admin/calendar",
    icon: Calendar,
    roles: ["admin", "astrologer", "customer"],
  },
  {
    title: "Broadcasting",
    href: "/admin/broadcasting",
    icon: Radio,
    roles: ["admin", "astrologer", "customer"],
  },

  // Astrologer-specific
  {
    title: "Dashboard",
    href: "/admin/astrologer",
    icon: LayoutDashboard,
    roles: ["astrologer"],
  },
  {
    title: "Training Center",
    href: "/admin/astrologer/training",
    icon: GraduationCap,
    roles: ["astrologer"],
  },
  {
    title: "My Profile",
    href: "/admin/astrologer/profile",
    icon: Users,
    roles: ["astrologer"],
  },
  {
    title: "My Packages",
    href: "/admin/astrologer/packages",
    icon: Package,
    roles: ["astrologer"],
  },
  {
    title: "Calendar Mgmt",
    href: "/admin/astrologer/calendar",
    icon: Calendar,
    roles: ["astrologer"],
  },
  {
    title: "Booked Slots",
    href: "/admin/astrologer/calendar/booked-slots",
    icon: Calendar,
    roles: ["astrologer"],
  },
  {
    title: "Appointments",
    href: "/admin/astrologer/appointments",
    icon: Calendar,
    roles: ["astrologer"],
  },
  {
    title: "Testimonials",
    href: "/admin/astrologer/testimonials",
    icon: MessageSquare,
    roles: ["astrologer"],
  },

  // Customer-specific
  {
    title: "Dashboard",
    href: "/admin/customer",
    icon: LayoutDashboard,
    roles: ["customer"],
  },
  {
    title: "Social Advocacy",
    href: "/admin/social-advo",
    icon: Megaphone,
    roles: ["customer"],
  },
  {
    title: "My Profile",
    href: "/admin/account",
    icon: Users,
    roles: ["customer"],
  },

  // Perennial-specific
  {
    title: "Dashboard",
    href: "/admin/perennial",
    icon: LayoutDashboard,
    roles: ["perennial"],
  },
  {
    title: "My Rituals",
    href: "/admin/perennial/rituals",
    icon: Sparkles,
    roles: ["perennial"],
  },
  {
    title: "Members",
    href: "/admin/perennial/members",
    icon: Users,
    roles: ["perennial"],
  },
  {
    title: "Relationship Details",
    href: "/admin/perennial/relationship-details",
    icon: Heart,
    roles: ["perennial"],
  },

  // Mystery School
  {
    title: "Dashboard",
    href: "/admin/mystery-school",
    icon: LayoutDashboard,
    roles: ["mystery"],
  },
  {
    title: "Training",
    href: "/admin/mystery-school/training",
    icon: GraduationCap,
    roles: ["mystery"],
  },

  // Diviner
  {
    title: "Dashboard",
    href: "/admin/diviner",
    icon: LayoutDashboard,
    roles: ["diviner"],
  },
  {
    title: "Orders",
    href: "/admin/diviner/orders",
    icon: ShoppingCart,
    roles: ["diviner"],
  },
  {
    title: "Transactions",
    href: "/admin/diviner/transactions",
    icon: CreditCard,
    roles: ["diviner"],
  },
  {
    title: "Training",
    href: "/admin/diviner/training",
    icon: GraduationCap,
    roles: ["diviner"],
  },

  // Affiliate
  {
    title: "Dashboard",
    href: "/admin/affiliate",
    icon: LayoutDashboard,
    roles: ["affiliate"],
  },
  {
    title: "Click Report",
    href: "/admin/affiliate/clicks",
    icon: BarChart3,
    roles: ["affiliate"],
  },
  {
    title: "Conversions",
    href: "/admin/affiliate/conversions",
    icon: Trophy,
    roles: ["affiliate"],
  },
];
